<template>
    <div class="main-container">
        <h2 class="main-title bottom-row">Redirects management</h2>
        <Loader v-if="isScriptsLoadInProgress"></Loader>
        <div class="main-form">
            <div class="form">
                <div>
                    <div class="multiple-inputs-wrap" style="white-space: nowrap; padding-top: 2px" v-for="(rd) in this.redirects" :key="rd.key">
                        <div class="form__input-box">
                            <label>
                                <input type="text" class="form__input" name="from" placeholder="from" v-model="rd.from" v-input-trim>
                            </label>
                        </div>
                        <div class="form__input-box">
                            <label>
                                <input type="text" class="form__input" name="to" placeholder="to" v-model="rd.to" v-input-trim>
                            </label>
                        </div>
                        <div class="form__input-box form__input-box--small">
                            <label>
                                <select class="form__select" v-model="rd.message">
                                    <option value="REDIRECT_MSG">REDIRECT_MSG</option>
                                </select>
                            </label>
                        </div>
                        <div class="form__input-box form__input-box--small">
                            <label>
                                <select class="form__select" v-model="rd.type">
                                    <option :value="301">301</option>
                                    <option :value="302">302</option>
                                </select>
                            </label>
                        </div>
                        <div class="btns-row__right-btns" >
                            <v-btn outlined color="indigo"
                                    @click="removeRow(rd.key)">
                                <span>delete</span>
                            </v-btn >
                        </div>
                    </div>
                </div>
                <div class="top-row1" style="padding-bottom: 20px">
                    <div v-if="errorMsgs.length > 0"><span style="color: red;">Errors:</span>
                        <div v-for="err in errorMsgs" v-bind:key="err">{{err}}</div>
                    </div>
                    <div class="btns-row__right-btns" style="padding-top: 10px">
                        <v-btn v-if="$checkRoles(['Administrator'])"
                               outlined color="red" large
                                @click="saveAllChanges()">
                            <Loader v-if="isScriptsLoadInProgress"></Loader>
                            <span v-else>Save Changes</span>
                        </v-btn>
                    </div>
                </div>
                <h2 class="main-title bottom-row" style="padding-top: 20px;">Add new row</h2>
                <div >
                    <div class="multiple-inputs-wrap" style="white-space: nowrap">
                        <div class="form__input-box">
                            <label>
                                <input type="text" class="form__input" placeholder="from" name="from" v-model="redirect.from" v-input-trim >
                                <div style="color: red">{{fromErrorMessage}}</div>
                            </label>
                        </div>
                        <div class="form__input-box">
                            <label>
                                <input type="text" class="form__input" placeholder="to" name="to" v-model="redirect.to" v-input-trim >
                                <div style="color: red">{{toErrorMessage}}</div>
                            </label>
                        </div>
                        <div class="form__input-box form__input-box--small">
                            <label>
                                <select class="form__select" v-model="redirect.message">
                                    <option value="REDIRECT_MSG">REDIRECT_MSG</option>
                                </select>
                            </label>
                        </div>
                        <div class="form__input-box form__input-box--small">
                            <label>
                                <select class="form__select" v-model="redirect.type">
                                    <option value="301">301</option>
                                    <option value="302">302</option>
                                </select>
                            </label>
                        </div>
                        <div class="btns-row__right-btns" >
                            <v-btn outlined color="indigo"
                                    @click="addNewRow()">
                                <span>add new row</span>
                            </v-btn >
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <InfoModal
                v-if="scriptIsSaved"
                :msg="infoModalMessage"
                :onCloseModal="closeInfoModal"
        ></InfoModal>
        <h2 class="main-title bottom-row" style="padding-top: 20px;">Import redirects from XML format</h2>
        <div class="" style="white-space: nowrap">
            <div class="form__input-box">
            <label>
                <v-textarea name="xmlRedirects" v-model="xmlRedirects" rows="20" cols="104" placeholder="put here redirects in old xml format"
                style="border: 1px solid #006db9; margin-bottom: 5px"></v-textarea>
            </label>
            </div>
            <div class="form__input-box">
                <v-btn outlined color="indigo"
                        @click="convertXmlToJson()">
                    <span>convert xml redirects to rows</span>
                </v-btn >
            </div>
        </div>

    </div>
</template>

<script>
  import Loader from '../../Loader/Loader.vue'
  import InfoModal from '../../InfoModal/InfoModal.vue'
  import config from '../../../config'
  import { validateRedirects } from '../../../utils/validation'
  import { ClearCacheService } from '../../../services/ClearCacheService'

  export default {
    components: {Loader, InfoModal},
    name: 'RedirectsEditForm',
    props: ['selectedArena'],
    data () {
      return {
        scriptIsSaved: false, // arena edited success flag
        isScriptsLoadInProgress: false,
        infoModalMessage: '',
        redirects: undefined,
        arena: undefined,
        redirect: {
          from: '',
          to: '',
          type: '',
          message: ''
        },
        fromErrorMessage: '',
        toErrorMessage: '',
        errorMsgs: [],
        xmlRedirects: ''
      }
    },
    created: function () {
      this.initForm()
    },
    watch: {
      selectedArena: function (newValue) {
        if (newValue) {
          this.initForm()
        }
      }
    },
    computed: {

    },
    methods: {
      initForm: function () {
        this.isScriptsLoadInProgress = true
        let arenaPromise = this.$http.get(`${config.apiUrl}/arena/table-model/get?domain=${this.selectedArena.domain.replace('www.', '')}`)
        Promise.all([arenaPromise])
          .then(([arenaPromise]) => {
            this.arena = arenaPromise.body
            this.redirects = JSON.parse(this.arena.redirects)
            if (this.redirects) {
              this.reindexRedirects()
            }
            this.isScriptsLoadInProgress = false
          }, error => {
            console.log(error)
            this.isScriptsLoadInProgress = false
          })
      },
      addNewRow: function () {
        this.fromErrorMessage = this.toErrorMessage = ''
        if (this.redirect.from === '') {
          this.fromErrorMessage = "Can't be empty"
          return
        }
        if (this.redirect.to === '') {
          this.toErrorMessage = "Can't be empty"
          return
        }
        if (this.redirect.from.startsWith('http')) {
          this.fromErrorMessage = "Can't be absolute url"
          return
        }
        if (!this.redirects) {
          this.redirects = []
        }
        this.redirects.push(this.redirect)
        this.reindexRedirects()
        this.redirect = {}
      },
      removeRow: function (key) {
        let filtered = []
        this.redirects.forEach(rd => {
          if (rd.key !== key) {
            filtered.push(rd)
          }
        })
        this.redirects = filtered
        this.reindexRedirects()
      },
      saveAllChanges: function () {
        this.removeEndSlash()
        this.errorMsgs = validateRedirects(this.redirects)
        if (this.errorMsgs.length === 0) {
          this.errorMsgs = []
          const url = `${config.apiUrl}/arena/redirects/save/?arenaDomain=${this.selectedArena.domain.replace('www.', '')}`
          const headers = {
            headers: {'Content-Type': 'application/json'}
          }
          const rawJson = JSON.stringify(this.redirects);
          const payload = `'${rawJson.replace(/'/g, "\\'")}'`;
          this.$http.post(url, payload, headers)
            .then(response => {
              this.showInfoModal('Changes are saved.')
              ClearCacheService.clearCacheRedirects()
            }, error => {
              console.log(error)
            })
        }
      },
      closeInfoModal: function () {
        this.scriptIsSaved = false
      },
      showInfoModal: function (message) {
        this.infoModalMessage = message
        this.scriptIsSaved = true
      },
      id: function (name, index) {
        return name + '-' + index
      },
      removeEndSlash: function () {
        this.redirects.forEach(rd => {
          if (rd.from.endsWith('/')) {
            rd.from = rd.from.substring(0, rd.from.length - 1)
          }
          if (rd.to.endsWith('/')) {
            rd.to = rd.to.substring(0, rd.to.length - 1)
          }
        })
      },
      convertXmlToJson: function () {
        if (window.DOMParser) {
          if (!this.redirects) this.redirects = []
          let parser = new DOMParser()
          let xmlDoc = parser.parseFromString(this.xmlRedirects, 'text/xml')
          let domain = this.selectedArena.domain.replace('www.', '')
          Array.prototype.slice.call(xmlDoc.getElementsByTagName('Redirect')).forEach(rd => {
            let from = rd.attributes['from'].nodeValue
            let to = rd.attributes['to'].nodeValue
            let type = rd.attributes['type'] ? rd.attributes['type'].nodeValue : '301'
            if (!from.startsWith('/')) {
              from = '/' + from
            }
            if (to.startsWith('https://' + domain) || to.startsWith('http://' + domain)) {
              to = to.replace('https://' + domain, '')
              to = to.replace('http://' + domain, '')
            }
            if (to.startsWith('~/')) {
              to = to.replace('~/', '/')
            }
            this.redirects.push({
              'from': from,
              'to': to,
              'type': type
            })
          })
          this.removeEndSlash()
          this.reindexRedirects()
          this.xmlRedirects = ''
        }
      },
      reindexRedirects: function () {
        let index = 0
        this.redirects.forEach((item) => {
          item.key = index++
        })
      }
    }
  }
</script>

<style scoped lang="scss" src="./RedirectsPage.scss"></style>
